import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useLoading } from "../../../../components/Loading";
import { useState } from "react";
import { useSnackbar } from "../../../../context/popup";
import { fetchData } from "../../../../services";
import DropDownConfig from "../../../Utils/DropDownConfig";


const InsurerRtoFilterDialog = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {    
    
    const {setCircleLoading} = useLoading();
    const {showSnackbar} = useSnackbar();

    //accordian states
    const [openActive, setOpenActive] = useState(false);
    const [openInsurer, setOpenInsurer] = useState(false);
    const [openInsurerCity, setOpenInsurerCity] = useState(false);

    //options states
    const [options, setOptions] = useState([]); 
    const [cityOptions, setCityOptions] = useState([]);   

    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "6px 8px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.5,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    const fetchInsurerRtoRegionList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/insurer/key_value_store?code=${DropDownConfig?.insurerRtoRegion}&dropdown=true`)
            
            if(response?.success){
                const formattedInsurers = response?.data?.items?.map((item) => ({
                    value: item?.id,
                    label: item?.companyName,
                })) || [];
                setOptions(formattedInsurers)
            }
            else{
                //throw error
                showSnackbar("Error Fetching List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Dropdown:', error);
            showSnackbar(error?.response?.data?.message, "error");
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchCityList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/insurer/city?dropdown=true`)
            
            if(response?.success){
                const formattedOptions = response?.data?.items?.map((item) => ({
                    value: item?.id,
                    label: item?.name,
                })) || [];
                setCityOptions(formattedOptions)
            }
            else{
                //throw error
                showSnackbar("Error Fetching List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Dropdown:', error);
            showSnackbar(error?.response?.data?.message, "error");
        }
        finally{
            setCircleLoading(false);
        }
    };

    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            gInsurerId: "",
            iCityId: "",
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 250,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",             
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                Insurer RTO Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1} sx={{
            maxHeight: 300, 
            overflowY: "auto"}}>
            <Grid2 container>
                <Grid2 size={{xs:12}}>
                    <MaterialBox mt={1}>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography variant="subtitle2" fontWeight="bold">
                            Active Status
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openActive}>
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: true },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === true} />}
                            label="Active"
                            sx={labelStyle}
                            />
                        </MenuItem>

                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: false },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === false} />}
                            label="Inactive"
                            sx={labelStyle}
                            />
                        </MenuItem>
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Insurer RtoRegion*/}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openInsurer;
                            setOpenInsurer(nextState);

                            if (nextState && options.length === 0) {
                                fetchInsurerRtoRegionList();
                            }
                        }}>
                        <MaterialTypography variant="subtitle2" fontWeight="bold">
                            Insurer RTO Region
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openInsurer ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openInsurer}>
                        {options?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "iRtoRegionId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.iRtoRegionId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Insurer City*/}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openInsurerCity;
                            setOpenInsurerCity(nextState);

                            if (nextState && cityOptions.length === 0) {
                                fetchCityList();
                            }
                        }}>
                        <MaterialTypography variant="subtitle2" fontWeight="bold">
                            Insurer City
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openInsurerCity ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openInsurerCity}>
                        {cityOptions?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "iCityId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.iCityId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
            </Grid2>
        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#93a6e8",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#bcc7e9",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default InsurerRtoFilterDialog;
